import { useState } from "react";
import { Nav, NavItem, NavLink, Popover, PopoverBody, TabContent, TabPane } from "reactstrap";
import { importAllImages } from "../utils";

const glitterImages = importAllImages(require.context('../styles/glitter', false, /\.(png|jpe?g|svg)$/));
const patternImages = importAllImages(require.context('../styles/pattern', false, /\.(png|jpe?g|svg)$/));

const colors = [
    "#6610f2",
    "#0dcaf0",
    "#6f42c1",
    "#800000",
    "#8B0000",
    "#B22222",
    "#FF0000",
    "#FA8072",
    "#FF6347",
    "#FF7F50",
    "#FF4500",
    "#D2691E",
    "#F4A460",
    "#FF8C00",
    "#FFA500",
    "#B8860B",
    "#DAA520",
    "#FFD700",
    "#808000",
    "#FFFF00",
    "#9ACD32",
    "#ADFF2F",
    "#7FFF00",
    "#7CFC00",
    "#008000",
    "#00FF00",
    "#32CD32",
    "#00FF7F",
    "#00FA9A",
    "#40E0D0",
    "#20B2AA",
    "#48D1CC",
    "#008B8B",
    "#00FFFF",
    "#00CED1",
    "#00BFFF",
    "#1E90FF",
    "#4169E1",
    "#000080",
    "#00008B",
    "#0000CD",
    "#0000FF",
    "#8A2BE2",
    "#9932CC",
    "#9400D3",
    "#800080",
    "#8B008B",
    "#FF00FF",
    "#C71585",
    "#FF1493",
    "#FF69B4",
    "#DC143C",
    "#A52A2A",
    "#CD5C5C",
    "#BC8F8F",
    "#F08080",
    "#FFFAFA",
    "#FFE4E1",
    "#E9967A",
    "#FFA07A",
    "#A0522D",
    "#FFF5EE",
    "#8B4513",
    "#FFDAB9",
    "#CD853F",
    "#FAF0E6",
    "#FFE4C4",
    "#DEB887",
    "#D2B48C",
    "#FAEBD7",
    "#FFDEAD",
    "#FFEBCD",
    "#FFEFD5",
    "#FFE4B5",
    "#F5DEB3",
    "#FDF5E6",
    "#FFFAF0",
    "#FFF8DC",
    "#F0E68C",
    "#FFFACD",
    "#EEE8AA",
    "#BDB76B",
    "#F5F5DC",
    "#FAFAD2",
    "#FFFFE0",
    "#FFFFF0",
    "#6B8E23",
    "#556B2F",
    "#8FBC8F",
    "#006400",
    "#228B22",
    "#90EE90",
    "#98FB98",
    "#F0FFF0",
    "#2E8B57",
    "#3CB371",
    "#F5FFFA",
    "#66CDAA",
    "#7FFFD4",
    "#2F4F4F",
    "#AFEEEE",
    "#E0FFFF",
    "#F0FFFF",
    "#5F9EA0",
    "#B0E0E6",
    "#ADD8E6",
    "#87CEEB",
    "#87CEFA",
    "#4682B4",
    "#F0F8FF",
    "#708090",
    "#778899",
    "#B0C4DE",
    "#6495ED",
    "#E6E6FA",
    "#F8F8FF",
    "#191970",
    "#6A5ACD",
    "#483D8B",
    "#7B68EE",
    "#9370DB",
    "#4B0082",
    "#BA55D3",
    "#DDA0DD",
    "#EE82EE",
    "#D8BFD8",
    "#DA70D6",
    "#FFF0F5",
    "#DB7093",
    "#FFC0CB",
    "#FFB6C1",
    "#000000",
    "#696969",
    "#808080",
    "#A9A9A9",
    "#C0C0C0",
    "#D3D3D3",
    "#DCDCDC",
    "#F5F5F5",
    "#FFFFFF"
]

function ColorsPicker({ pickedColor, onPick, targetElem }) {
    const [selectedTab, setSelectedTab] = useState('solid')
    const [isOpen, setIsOpen] = useState(false)

    function handlePick(data) {
        onPick(data)
        setIsOpen(false)
        setSelectedTab('solid')
    }

    return (
        <Popover
            isOpen={isOpen}
            placement="right"
            target={targetElem}
            offset={[0, 0]}
            trigger="legacy"
            toggle={() => {
                if(isOpen) setSelectedTab('solid')
                setIsOpen(!isOpen)
            }}
        >
            <PopoverBody>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={selectedTab === 'solid' ? 'active' : ''} onClick={() => setSelectedTab('solid')}>
                            Solid
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={selectedTab === 'glitter' ? 'active' : ''} onClick={() => setSelectedTab('glitter')}>
                            Glitter
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={selectedTab === 'pattern' ? 'active' : ''} onClick={() => setSelectedTab('pattern')}>
                            Pattern
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={selectedTab}>
                    <TabPane tabId="solid">
                        <div id="color-circles-cont">
                            {colors.map(color =>
                                <div key={color} className={"color-circle-cont" + (color === pickedColor.color ? "active" : "")}>
                                    <div style={{ backgroundColor: color }}
                                        className="color-circle"
                                        onClick={() => handlePick({ color, type: 'solid' })}
                                    />
                                </div>
                            )}
                        </div>
                    </TabPane>
                    <TabPane tabId="glitter">
                        <div id="color-circles-cont">
                            {Object.keys(glitterImages).map(key => glitterImages[key]).map(url =>
                                <div key={url}
                                    className={"color-image " + (url === pickedColor.color ? "active" : "")}
                                    onClick={() => handlePick({ color: url, type: 'glitter' })}
                                >
                                    <img src={url} alt="glitter" />
                                </div>
                            )}
                        </div>
                    </TabPane>
                    <TabPane tabId="pattern">
                        <div id="color-circles-cont">
                            {Object.keys(patternImages).map(key => patternImages[key]).map(url =>
                                <div key={url}
                                    className={"color-image " + (url === pickedColor.color ? "active" : "")}
                                    onClick={() => handlePick({ color: url, type: 'pattern' })}
                                >
                                    <img src={url} alt="pattern" />
                                </div>
                            )}
                        </div>
                    </TabPane>
                </TabContent>
            </PopoverBody>
        </Popover>
    )
}

export default ColorsPicker;
